<h1 mat-dialog-title>Print Settings</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>Recurring Schedule</mat-label>
      <mat-select name="results.recurringType" [(ngModel)]="results.recurringType">
        <mat-option [value]="1">Weekly</mat-option>
        <mat-option [value]="2">Monthly</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="results.recurringType == 1">
      <mat-label>Day Of Week</mat-label>
      <mat-select name="results.dayOfWeek" [(ngModel)]="results.dayOfWeek">
        <mat-option [value]="0">Sunday</mat-option>
        <mat-option [value]="1">Monday</mat-option>
        <mat-option [value]="2">Tuesday</mat-option>
        <mat-option [value]="3">Wednesday</mat-option>
        <mat-option [value]="4">Thursday</mat-option>
        <mat-option [value]="5">Friday</mat-option>
        <mat-option [value]="6">Saturday</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="results.recurringType == 2">
      <mat-label>Day of Month</mat-label>
      <mat-select name="results.dayOfMonth" [(ngModel)]="results.dayOfMonth">
        <mat-option [value]="1">1st</mat-option>
        <mat-option [value]="15">15th</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Email To</mat-label>
      <input matInput name="results.emailTo" [(ngModel)]="results.emailTo" />
    </mat-form-field>
  </form>

</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onConfirmClick()">Save</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
